const classes = state => state.classes;
const subjectsClasses = state => state.subjectsClasses;
const exerciseFilter = state => state.exerciseFilter;
const exerciseDetail = state => state.exerciseDetail;
const question_exercise = state => state.question_exercise;
const question_exercise_info = state => state.question_exercise_info;
const math_value = state => state.math_value;
const open_math = state => state.open_math;
const validate_question = state => state.validate_question;
const question_activity = state => state.question_activity;
const check_answer = state => state.check_answer;
const question_valid_data = state => state.question_valid_data;
const allClasses = state => state.allClasses;
const getExerciseDetailNumber = state => state.getExerciseDetailNumber;
const getPracticeType = state => state.getPracticeType;
const getLisstPracticeTypeBook = state => state.getLisstPracticeTypeBook;
const getActive = state => state.getActive;
const practiceActive = state => state.practiceActive;
const practiceTypes = state => state.practiceTypes;
const exerciseClassCurr = state => state.exerciseClassCurr;
const questionsExercise = state => state.questionsExercise;
const ebooksDetail = state => state.ebooksDetail;


export default {
    classes,
    subjectsClasses,
    exerciseFilter,
    exerciseDetail,
    question_exercise,
    question_exercise_info,
    math_value,
    open_math,
    validate_question,
    question_activity,
    check_answer,
    question_valid_data,
    allClasses,
    getExerciseDetailNumber,
    getPracticeType,
    getLisstPracticeTypeBook,
    getActive,
    practiceActive,
    practiceTypes,
    exerciseClassCurr,
    questionsExercise,
    ebooksDetail
};